// Get activities
const getActivitiesStart = (state) => ({ ...state, error: "", loading: true });
const getActivitiesSuccess = (state, payload) => {
  return {
    ...state,
    polls: payload.polls,
    advertisements: payload.advertisements.map((adv) => ({
      ...adv,
      selectedContacts: adv.selected_contacts,
    })),
    error: "",
    loading: false,
  };
};
const getActivitiesFail = (state, payload) => {
  return {
    ...state,
    error: payload,
    loading: false,
  };
};

// add activity
const addActivityStart = (state) => ({ ...state, error: "", loading: true });
const addActivitySuccess = (state, payload) => {
  if (Object.keys(payload).indexOf("poll") !== -1) {
    const newPolls = [...state.polls, payload.poll];
    return {
      ...state,
      polls: newPolls,
      error: "",
      loading: false,
    };
  }
  if (Object.keys(payload).indexOf("advertisement") !== -1) {
    const newAdvertisements = [...state.advertisements, payload.advertisement];
    return {
      ...state,
      advertisements: newAdvertisements,
      error: "",
      loading: false,
    };
  }
  return {
    ...state,
    error: "",
    loading: false,
  };
};
const addActivityFail = (state, payload) => {
  return {
    ...state,
    error: payload,
    loading: false,
  };
};

// Add advertisment
const addAdvertismentStart = (state) => ({ ...state, loading: false, error: "" });
const addAdvertismentSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    error: "",
    advertisements: state.advertisements.concat({
      ...action.advertisements,
      canEditAndDelete: action.advertisements.sendNow === false,
      //  && action.advertisements.dateTime > action.advertisements.created,
    }),
  };
};
const addAdvertismentFail = (state, { error }) => ({ ...state, loading: false, error });

// Delete activity(adv)
const deleteActivityStart = (state) => ({ ...state, loading: true, error: "" });
const deleteActivitySuccess = (state, action) => {
  const updatedActivities = state.advertisements.filter(
    (adv) => adv._id !== action.advertisementId,
  );
  return { ...state, advertisements: updatedActivities, error: "", loading: false };
};
const deleteActivityFail = (state, { error }) => ({ ...state, loading: false, error });

// Edit activities(Adv)
const editAdvertismentStart = (state, action) => ({ ...state, loading: true, error: "" });
const editAdvertismentSuccess = (state, action) => {
  const updatedAdvertisments = [
    ...state.advertisements.map((adv) => {
      return adv._id === action.payload._id
        ? {
            ...action.payload,
            canEditAndDelete:
              action.payload.sendNow === false || action.payload.sendNow === undefined,
          }
        : adv;
    }),
  ];
  return {
    ...state,
    loading: false,
    error: "",
    advertisements: updatedAdvertisments,
  };
};
const editAdvertismentFail = (state, { error }) => ({ state, loading: false, error });

const patchPollOption = (state, payload) => {
  if (state.polls && state.polls.length) {
    const polls = [...state.polls].filter((poll) => poll._id.toString() !== payload._id.toString());
    polls.push(payload);
    return { ...state, polls };
  }
  return { ...state };
};

export {
  getActivitiesStart,
  getActivitiesSuccess,
  getActivitiesFail,
  addActivityStart,
  addActivitySuccess,
  addActivityFail,
  patchPollOption,
  addAdvertismentStart,
  addAdvertismentSuccess,
  addAdvertismentFail,
  deleteActivityStart,
  deleteActivitySuccess,
  deleteActivityFail,
  editAdvertismentStart,
  editAdvertismentSuccess,
  editAdvertismentFail,
};
